import { Provider } from "@angular/core";
import { ClaimSearchService } from "./cliam-search.service";
import { QuotePolicySearchService } from "./quote-policy-search.service";
import { EcoMasterData } from "./eco-master.service";
import { EcoAgencyAgent } from "./eco-agency-agent.service";
import { CopyQuoteService } from "./copy-quote.service";
import { IssueNewBusinessService } from "./issue-new-business.service";
import { FormsECOService } from "./formsECO.service";
import { PolicyMasterDataService } from "./policy-master.service";

import { PolicyDownloadService } from "./policy-download.service";
import { KnrPolicyQuoteService } from "libs/data-service/kidnap-ransom/knr-policy-quote.service";
import {WeatherQuoteService} from "libs/data-service/weather/weather-quote.service";
// services
export * from "./cliam-search.service";
export * from "./quote-policy-search.service";
export * from "./smarty-street-sdk.service";
export * from "./eco-master.service";
export * from "./eco-master.service";
export * from "./quote-create-bussiness.service";
export * from "./eco-agency-agent.service";
export * from "./quote-step.service";
export * from "./copy-quote.service";
export * from "./subjectivity.service";
export * from "./form-validation.service";
export * from "./issue-new-business.service";
export * from "./formsECO.service";
export * from "./policy-master.service";

export * from "./policy-download.service";
export * from "./kidnap-ransom/knr-policy-quote.service";
export * from "libs/data-service/weather/weather-quote.service";

// definitions
// export * from './def/get-dashboard';
export {ClaimSearchRequest,ClaimSearchResponse,ClaimSearchResult} from "./def/claim-search.d";
export {PolicySearchRequest,PolicySearchResponse,PolicySearchResult} from "./def/policy-search.d";
export * from "./def/quote-policy-search";
export {EcoSearchRequest,EcoSearchResponse,EcoSearchResult} from "./def/eco-dashboard-search.d";
export * from "./def/quote-general.def";
export { EcoAgencyRequest,ContactRequest,ContactResponse,
  UpdateUserConfigurableDataElement,ContactElementUpdateRequests,
  Addresses,EcoAgencyResponse,ClaimHandler

} from "./def/eco-agency-agent.d";
export {SaveEventRequest,policyDataElements,UpdateEventDetails,
  UpdateUserConfigurableDataElements,CreateActivityLogItem,Risk,
  Coverage,RiskDataElements,ElementUpdateRequest,SaveEventResponse
} from "./def/events.d";
export { Moment } from "moment";
export {PolicyTxnRequest,PolicyTxnResponse,PolicyMovement,
  AdditionalSummaries,CreateActivityLogItemObj,UWQuotes,
  UWQuotaShares,ProducerCommissions,LOBs,LOBRisks,Coverages,
  LOBRiskDataElements,ElementUpdateRequests,PolicyContacts,
  QuoteOptions
} from "./def/quote-policy-step.d";
export {CopyQuoteRequest,CopyQuoteResponse,CopyQuoteResponselist} from "./def/copy-quote.d";
export {SaveSubjectiviyRequest,GetPolicySubjectivitiesRequest,SaveMiscellaneousChangesRequest,
  SaveMiscellaneousChangesResponse,PolicySubjectivityResponse,SubjectivityRequest,
  Subjectivity
} from "./def/subjectivity.d";
export {UpdateAndDownloadQuoteECO,CreateActivityLogItemData,PolicyDataElements,
  DownloadQuoteECO
} from "./def/updateAndDownloadQuoteECO.d";

export {
  EcoMasterRequest,
  EcoMasterResponse,
  Country,
  StateOrProvince,
  Underwriters,
  TermTypes,
  PolicyTypes,
  SubmissionTypes,
  RenewalOptions,
  UnderwriterAssistants,
  PaymentPlans
} from "../data-service/def/eco-master";
export {IssueNewBusinessRequest,CreateActivityLogItemForNB,IssueNewBusinessResponse} from "./def/issue-new-business.d";
export {EndorsmentFormsRequest,EndorsementFormsResponse,AvailableFormsResponse,
  ApproveQuoteRequest,EndorsementForms,AvailableForms,AddOptionalEndorsementFormsECO,
  CreateActivityLogItems,PolicyDataElement,ElementUpdateRequestObj,OptionalEndorsementForms,
  CustomFields,AddOptionalEndorsementResponse
} from "./def/eco-endorsment-forms.d";
export {KnrPolicySearchRequest} from "./def/knr-quote-policy-search.d"
export * from "./def/knrsubjectivity"
export const DataServiceProviders: Provider[] = [
  ClaimSearchService,
  QuotePolicySearchService,
  EcoMasterData,
  EcoAgencyAgent, 
  CopyQuoteService,
  IssueNewBusinessService,
  FormsECOService,
  PolicyMasterDataService,
  PolicyDownloadService,
  KnrPolicyQuoteService,
  WeatherQuoteService
];
